import { render, staticRenderFns } from "./account-list.vue?vue&type=template&id=63f37410&scoped=true&"
import script from "./account-list.vue?vue&type=script&lang=js&"
export * from "./account-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f37410",
  null
  
)

export default component.exports